import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-map-maker-faq",
  "use": "icon-map-maker-faq-usage",
  "viewBox": "0 0 14 20.363",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 20.363\" id=\"icon-map-maker-faq\">\n  <path id=\"icon-map-maker-faq_np_map-marker_888711_000000\" d=\"M34.082,16.668a6.98,6.98,0,0,0-7,7c0,3.881,7,13.363,7,13.363s7-9.482,7-13.363A6.98,6.98,0,0,0,34.082,16.668Zm0,10.181a3.182,3.182,0,1,1,3.182-3.182A3.151,3.151,0,0,1,34.082,26.849Z\" transform=\"translate(-27.082 -16.668)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/map-maker-faq.svg
// module id = 148
// module chunks = 0 1 2